import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api/v1`;

const client = axios.create({ baseURL: API_BASE });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("hi_access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshPromise = null;

client.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const refreshToken = localStorage.getItem("hi_refresh_token");
    if (error.response?.status === 401 && !original._retry && refreshToken && !original.url.includes("/auth/")) {
      original._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = axios
            .post(`${API_BASE}/auth/refresh`, { refreshToken })
            .then((r) => r.data.data)
            .finally(() => {
              refreshPromise = null;
            });
        }
        const data = await refreshPromise;
        localStorage.setItem("hi_access_token", data.accessToken);
        localStorage.setItem("hi_refresh_token", data.refreshToken);
        original.headers.Authorization = `Bearer ${data.accessToken}`;
        return client(original);
      } catch (e) {
        localStorage.removeItem("hi_access_token");
        localStorage.removeItem("hi_refresh_token");
        localStorage.removeItem("hi_user");
        window.location.href = "/login";
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);

export const unwrap = (res) => res.data.data;

// Distinguishes "the server said no" from "the server was never reached". Without this a
// wrong REACT_APP_BACKEND_URL looks identical to a bad password, since axios gives no
// `response` at all on a network/CORS failure. Names API_BASE so the real target is visible.
export const apiErrorMessage = (err, fallback) =>
  !err?.response
    ? `Cannot reach the server at ${API_BASE} — is the backend running?`
    : err.response.data?.error?.message || fallback;

export default client;
